import React from 'react';
import './Payments.css';

function Payments() {
  return (
    <div className="payments-page">
      <div className="container">
        <section className="payments-hero">
          <h1>🛒 Secure Payments</h1>
          <p className="subtitle">Yoco & PayPal Protected</p>
        </section>

        <section className="payments-content">
          <p className="intro-text">
            Shop with complete confidence knowing your payments are safe and protected. 
            We use trusted payment gateways to ensure your personal and financial information 
            remains secure at all times.
          </p>

          <div className="payments-options">
            <h2>Payment options include:</h2>
            <ul className="payments-list">
              <li>Yoco secure card payments</li>
              <li>PayPal for added buyer protection</li>
              <li>Encrypted checkout for peace of mind</li>
            </ul>
          </div>

          <section className="payments-commitment">
            <p>
              Your security matters to us — from the moment you browse to the moment you 
              complete your purchase.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Payments;
